export class Selectable<T> {
  constructor(readonly value: T, public checked: boolean, public color?: string) {
  }
}

export const capitalizeFirstLetter = (val: string) => val.charAt(0).toUpperCase() + val.slice(1);

export const formatDate = (date: string) => {
  if (!date || date.length === 10) {
    return date
  }
  const dateValue = new Date(date)

  const day = String(dateValue.getDate()).padStart(2, "0")
  const month = String(dateValue.getMonth() + 1).padStart(2, "0")
  const year = dateValue.getFullYear()

  return `${day}-${month}-${year}`
}

export const isoDatestring = (date: string) => {
  if (!date) {
    return date
  }

  const formattedDate = formatDate(date)
  const day = +formattedDate.substring(0, 2)
  const month = +formattedDate.substring(3, 5)
  const year = +formattedDate.substring(6, 10)

  return new Date(Date.UTC(year, month-1, day)).toISOString()
}

export const firstFromArray = <T>(array:T[]): T | null  => array && array.length > 0 ? array[0] : null
